import React from 'react';
import Typography from '@mui/material/Typography';
import RHFTextField from '#component/form/rhf/rhf-text-field';
import RHFPhoneField from '#component/form/rhf/rhf-phone-field';
import RHFRadioGroup from '#component/form/rhf/rhf-radio-group';
import RHFSwitch from '#component/form/rhf/rhf-switch';
import { getPagesList } from '#component/user/pages';
import PreloaderComponent from '#component/preloader';
import { ProjectField } from '#component/general/form-project-field/project-field';
import {
  ButtonCnt,
  DivIcon,
  LastField,
  PagesList,
  SettingsCnt,
  StyledButton,
  StyledPaper,
  StyledTitle,
  StyledWarningIcon,
  SwitchAlign,
  SwitchCnt,
  UserRoleField
} from './styles';
import { isTrailLabel } from '#helper';

const legacyClasses = {
  radio: 'radio',
  radioLabel: 'radioLabel',
  project: 'project',
  mobilePlaceholder: 'mobilePlaceholder'
};

class UserSettingsForm extends React.PureComponent {
  render() {
    const {
      history,
      isDirty,
      isSubmitting,
      user,
      requestStatus,
      editable,
      title,
      projects,
      account,
      settingsUserForm,
      withoutProjects,
      selectedProject,
      mainCntStyle
    } = this.props;

    const pagesList = getPagesList(account.userType).filter(
      page => !isTrailLabel(page.label)
    );

    if (['idle', 'loading'].includes(requestStatus)) {
      return <PreloaderComponent />;
    }

    return (
      <SettingsCnt style={mainCntStyle}>
        <SwitchCnt>
          <StyledTitle variant="h4" gutterBottom>
            {title}
          </StyledTitle>

          {settingsUserForm &&
            user.firstName &&
            account.userType === 2 &&
            !editable && (
              <SwitchAlign>
                <RHFSwitch
                  name="disabled"
                  label="Active"
                  // Value will be boolean but the API expects Number(0/1) which we handle on submit
                />
              </SwitchAlign>
          )}
        </SwitchCnt>

        <StyledPaper elevation={0}>
          {withoutProjects && (
            <Typography variant="button" gutterBottom>
              <StyledWarningIcon />
              <span style={{ verticalAlign: 'middle' }}>
                User without projects
              </span>
            </Typography>
          )}

          {account.userType === 2 && (
            <UserRoleField
              name="userType"
              label="User role"
              data={{
                items: [
                  { id: 2, value: '10', label: 'Standard' },
                  { id: 1, value: '2', label: 'Extended' },
                  { id: 3, value: '1', label: 'Quality Manager' }
                ]
              }}
              disabled={!editable && account.userType !== 2}
            />
          )}

          <RHFTextField
            name="firstName"
            label="First name"
            variant="outlined"
            fullWidth
            margin="normal"
            disabled={!editable && account.userType !== 2}
          />

          <RHFTextField
            name="lastName"
            label="Last name"
            variant="outlined"
            fullWidth
            margin="normal"
            disabled={!editable && account.userType !== 2}
          />

          <RHFPhoneField
            name="phoneNumber"
            label="Phone number"
            variant="outlined"
            fullWidth
            margin="normal"
            disabled={!editable && account.userType !== 2}
          />

          <RHFTextField
            name="email"
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            disabled={!editable}
          />

          {account.userType < 10 && projects.length > 0 && (
            <ProjectField
              classes={legacyClasses}
              label="Default project"
              defaultData={selectedProject}
            />
          )}

          <LastField
            name="defaultPage"
            label="Main page"
            variant="outlined"
            select
            margin="normal"
          >
            {pagesList.map(page => (
              <PagesList key={page.route} value={page.route}>
                <DivIcon>{page.icon}</DivIcon>
                <div>{page.label}</div>
              </PagesList>
            ))}
          </LastField>

          <RHFRadioGroup
            name="measurementSystem"
            label="Measurement system"
            data={{
              items: [
                { id: 1, value: 'us', label: 'Imperial' },
                { id: 2, value: 'metric', label: 'Metric' }
              ]
            }}
          />
        </StyledPaper>

        <ButtonCnt>
          <StyledButton
            variant="outlined"
            onClick={() => history.goBack()}
          >
            Cancel
          </StyledButton>

          <StyledButton
            disabled={!isDirty || isSubmitting}
            type="submit"
            variant="contained"
            color="secondary"
          >
            Save
          </StyledButton>
        </ButtonCnt>
      </SettingsCnt>
    );
  }
}

export default UserSettingsForm;
